import React from 'react';

/** images */
import time2min from '../../assets/images/time2MinGif.gif';
import time30min from '../../assets/images/time30MinGif.gif';
import TenantConfig from '../../config';

const renderImageByTenant = (isLong) => {
  return (
    <div className={`amazonImageDiv ${isLong ? 'waitLongImage' : 'waitImage'}`}>
      <img src={isLong ? time30min : time2min} />
    </div>
  );
};

const renderDescriptionByTenant = (isLong) => {
  return isLong
    ? 'Reviewing and verifying information this may take up to 30 minutes...'
    : renderDescriptionByTenantNotLong();
};
const renderDescriptionByTenantNotLong = () => {
  return TenantConfig?.transition?.transitionDescriptionMessage !== null
    ? TenantConfig?.transition?.transitionDescriptionMessage
    : 'Reviewing and verifying information...';
};
const renderTitleByTenant = () => {
  return TenantConfig?.transition?.transitionTitleMessage !== null
    ? TenantConfig?.transition?.transitionTitleMessage
    : 'Hold on, we are making some calls!';
};
const Transition = ({ isLong }) => {
  return (
    <div className="review-page">
      <h1 className="title">{renderTitleByTenant()}</h1>
      <h3 className="subtitle">{renderDescriptionByTenant(isLong)}</h3>
      {renderImageByTenant(isLong)}
    </div>
  );
};

export default Transition;
